import { createActionConst } from '../../../../utils/action.utils';

const PASSWORD_GROUPS_NAMESPACE = 'PASSWORD_GROUPS';

export const GET_PASSWORD_GROUPS = createActionConst(PASSWORD_GROUPS_NAMESPACE, 'GET_PASSWORD_GROUPS');
export const SAVE_PASSWORD_GROUP = createActionConst(PASSWORD_GROUPS_NAMESPACE, 'SAVE_PASSWORD_GROUP');

export const STORE_PASSWORD_GROUPS = createActionConst(PASSWORD_GROUPS_NAMESPACE, 'STORE_PASSWORD_GROUPS');
export const CLEAR_PASSWORD_GROUPS = createActionConst(PASSWORD_GROUPS_NAMESPACE, 'CLEAR_PASSWORD_GROUPS');
